import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Link,
  Typography,
  Switch,
} from "@mui/material";
import CustomButton from "shared/custom-button/CustomButton";
import { colors } from "app/providers/theme/colors-type";
import styles from "features/cancer-protection/step-3/ui/DocumentStep.module.css";
import { useAppDispatch, useAppSelector } from "shared/utils/hooks/useRedux";
import {
  IProgramsArray,
  IStepTree,
} from "entities/cancer-protection/step-3/types/StepTree-interface";
import FileIcon from "shared/assets/FileIcon";
import { programs, textInfo } from "entities/cancer-protection/step-3/selector";
import { DeclarationModal } from "./DeclarationModal";
import {
  FormFieldsStepOne,
  Programs,
} from "entities/cancer-protection/step-1/selector";
import { FormFieldsStepTwo } from "entities/cancer-protection/step-2/selsctor";
import { fetchCalculation } from "entities/cancer-protection/step-3/action/fetch-step-tree";
import Loader from "shared/loader/Loader";
import { updateField } from "entities/cancer-protection/step-3";
import AppStoreImg from "shared/assets/AppStoreImg";
import GooglePlayImg from "shared/assets/GooglePlayImg";

import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import RuStoreImg from "shared/assets/RuStoreImg";
import ModalWidget from "shared/modal/Modal";

interface DocumentStepProps {
  formState: IStepTree;
  errors: Record<string, string>;
  handleNextStep: () => void;
  handleCheckboxChange: (
    fieldName: keyof IStepTree
  ) => (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  handleOpenPolicy: () => void;
  errorsValidate: Record<string, string>;

  handleNext: () => void;
  windowWidth: number;
}

export const DocumentStep: React.FC<DocumentStepProps> = ({
  formState,
  errors,
  handleNextStep,
  handleCheckboxChange,
  handleOpenPolicy,
  errorsValidate,
  windowWidth,
  handleNext,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { TextInfo } = useAppSelector(textInfo);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleAcceptDeclaration = () => {
    handleCheckboxChange("PolicyholderAgreement")(null as any, true);
  };
  const dispatch = useAppDispatch();
  const programsArrayStepOne = useAppSelector(Programs);
  const fieldsStepOne = useAppSelector(FormFieldsStepOne);
  const selectedProgram = programsArrayStepOne.Programs?.find(
    (program) => program.ID === fieldsStepOne.ProgramId
  );
  const { AgentSalesDataID } = useAppSelector(FormFieldsStepOne);

  const formatNumberWithSpaces = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  useEffect(() => {
    dispatch(
      fetchCalculation({
        ProgramID: fieldsStepOne.ProgramId,
        AgentSalesDataID: AgentSalesDataID,
      })
    );
  }, []);

  const otherPrograms = useAppSelector(programs);

  const [selectedProgramsIds, setSelectedProgramsIds] = useState<string[]>([
    fieldsStepOne.ProgramId,
  ]);
  const [finalPremium, setFinalPremium] = useState(
    selectedProgram?.InsurancePremium
  );

  const handleToggle = (programId: string, checked: boolean) => {
    setSelectedProgramsIds((prev) =>
      checked ? [...prev, programId] : prev.filter((id) => id !== programId)
    );
  };
  const additionalPrograms = otherPrograms.ProgramsArray.slice(1);
  useEffect(() => {
    if (otherPrograms.ProgramsArray.length > 0) {
      const totalPremium = otherPrograms.ProgramsArray.filter((program) =>
        selectedProgramsIds.includes(program.ID)
      ).reduce((sum, program) => sum + program.Premium, 0);
      setFinalPremium(totalPremium);
      dispatch(updateField({ field: "FinalPremium", value: totalPremium }));
      dispatch(
        updateField({
          field: "SelectedProgramsIds",
          value: selectedProgramsIds,
        })
      );
    }
  }, [selectedProgramsIds, otherPrograms.ProgramsArray]);

  const [isModalOpenProgramOther, setIsModalOpenProgramOther] = useState(false);

  const [selectedProgramOther, setSelectedProgramOther] =
    useState<IProgramsArray | null>(null);
  const handleDesc = (programId: string) => {
    const program = additionalPrograms.find((item) => item.ID === programId);
    if (program) {
      setIsModalOpenProgramOther(true);
      setSelectedProgramOther(program);
    }
  };
  const handleCloseModalProgramOther = () => {
    setIsModalOpenProgramOther(false);
    setSelectedProgramOther(null);
  };

  if (otherPrograms.isLoadingPrograms) {
    return <Loader title="Пожалуйста подождите..." />;
  }
  return (
    <Box>
      <Box className={styles.formBox}>
        <Box className={styles.titleBox}>
          <h4>Итого премия к оплате</h4>
        </Box>
        <Box className={styles.fieldBox}>
          <Box className={styles.premium}>
            <span>
              {finalPremium ? formatNumberWithSpaces(finalPremium) : ""}{" "}
              <CurrencyRubleIcon fontSize="small" />
            </span>
          </Box>
          {additionalPrograms.length > 0 && (
            <Box className={styles.otherPrograms}>
              {additionalPrograms.map((programItem) => (
                <Box key={programItem.ID} className={styles.programIten}>
                  <Box>
                    <p className={styles.suggestion}>
                      {programItem.Suggestion}
                    </p>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <p className={styles.colorPremium}>
                        {" "}
                        +{programItem.Premium} руб.{" "}
                      </p>
                      <p className={styles.previousPrice}>
                        {programItem.PreviousPrice} руб.
                      </p>
                    </Box>
                    <CustomButton
                      title="Подробнее"
                      handleClick={() => handleDesc(programItem.ID)}
                      textColor={colors.primary}
                      backgroundColor="none"
                      border={colors.primary}
                      width="100px"
                      gap="10px"
                      borderRadius="4px"
                      padding="3px"
                    />
                  </Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={selectedProgramsIds.includes(programItem.ID)}
                        onChange={(e) =>
                          handleToggle(programItem.ID, e.target.checked)
                        }
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#0054E6",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#0054E6",
                            },
                        }}
                      />
                    }
                    label=""
                  />
                </Box>
              ))}
            </Box>
          )}
          <ModalWidget
            open={isModalOpenProgramOther}
            handleClose={handleCloseModalProgramOther}
            title=""
            closeIconPosition="right"
            widthProps={windowWidth < 700 ? 300 : 650}
          >
            {selectedProgramOther && (
              <Box className={styles.modalBox}>
                <h3>{selectedProgramOther.Suggestion}</h3>
                {selectedProgramOther.Description && (
                  <Box className={styles.descriptionModal}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedProgramOther.Description || "",
                      }}
                    ></p>
                  </Box>
                )}

                <Box className={styles.premiumModal}>
                  <Box className={styles.premiumModalLine}>
                    <p>Страховая сумма</p>
                    <span>
                      {formatNumberWithSpaces(selectedProgramOther.Sum)}{" "}
                      <CurrencyRubleIcon fontSize="small" />
                    </span>
                  </Box>
                  <Box className={styles.premiumModalLine}>
                    <p>Стоимость полиса</p>
                    <Box className={styles.premiumModalBox}>
                      <p className={styles.previousPriceModal}>
                        {selectedProgramOther.PreviousPrice} руб.
                      </p>
                      <span className={styles.colorPremium}>
                        {formatNumberWithSpaces(selectedProgramOther.Premium)}{" "}
                        <CurrencyRubleIcon fontSize="small" />
                      </span>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </ModalWidget>
          <Box className={styles.checkboxContainer}>
            <p>Я подтверждаю, что до оплаты ознакомился(-ась) с </p>
            <FormControlLabel
              control={
                <Checkbox
                  name="KidAgree"
                  checked={Boolean(formState.KidAgree)}
                  onChange={handleCheckboxChange("KidAgree")}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  <Link
                    href="https://hr-dms.ugsk.ru/%D0%9A%D0%98%D0%94_%D0%9E%D0%BD%D0%BA%D0%BE%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="always"
                  >
                    Ключевым информационным документом
                  </Link>
                </Typography>
              }
            />
            {errorsValidate["KidAgree"] && (
              <Typography color="error" variant="body2">
                {errorsValidate["KidAgree"]}
              </Typography>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  name="PolicyAgree"
                  checked={Boolean(formState.PolicyAgree)}
                  onChange={handleCheckboxChange("PolicyAgree")}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  <Link onClick={handleOpenPolicy}>Полисом-офертой</Link>
                </Typography>
              }
            />
            {errorsValidate["PolicyAgree"] && (
              <Typography color="error" variant="body2">
                {errorsValidate["PolicyAgree"]}
              </Typography>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  name="InsuranceRulesAgree"
                  checked={Boolean(formState.InsuranceRulesAgree)}
                  onChange={handleCheckboxChange("InsuranceRulesAgree")}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  <Link
                    href="https://ugsk.ru/pravila/109.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="always"
                  >
                    Правилами страхования
                  </Link>
                </Typography>
              }
            />
            {errorsValidate["InsuranceRulesAgree"] && (
              <Typography color="error" variant="body2">
                {errorsValidate["InsuranceRulesAgree"]}
              </Typography>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  name="AcceptanceAgree"
                  checked={Boolean(formState.AcceptanceAgree)}
                  onChange={handleCheckboxChange("AcceptanceAgree")}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  Я понимаю, что оплата страховой премии является акцептом{" "}
                  <Link onClick={handleOpenPolicy}>Полиса-оферты.</Link>
                </Typography>
              }
            />
            {errorsValidate["AcceptanceAgree"] && (
              <Typography color="error" variant="body2">
                {errorsValidate["AcceptanceAgree"]}
              </Typography>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  name="PolicyholderAgreement"
                  checked={Boolean(formState.PolicyholderAgreement)}
                  onChange={(e, checked) => {
                    if (!checked) {
                      handleCheckboxChange("PolicyholderAgreement")(e, checked);
                    } else {
                      handleOpenModal();
                    }
                  }}
                  sx={{
                    color: "grey.500",
                    "&.Mui-checked": {
                      color: colors.primary,
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  Я подтверждаю соответсвие и согласие с условиями{" "}
                  <Link
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenModal();
                    }}
                    underline="always"
                  >
                    Декларации.
                  </Link>
                </Typography>
              }
            />
            {errorsValidate["PolicyholderAgreement"] && (
              <Typography color="error" variant="body2">
                {errorsValidate["PolicyholderAgreement"]}
              </Typography>
            )}
          </Box>

          {/* <Box className={styles.FileItemBorder}>
            <span>
              <FileIcon />
            </span>
            <a onClick={handleOpenPolicy}>Образец договора страхования</a>
          </Box> */}

          {windowWidth <= 700 ? (
            <>
              <Box className={styles.infoText}>
                <p>Полис также будет доступен в приложении</p>
                <span>Ю-Здоровье</span>
              </Box>
              <Box className={styles.linkAppBox}>
                <a
                  href="https://apps.apple.com/ru/app/%D1%8E-%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D0%B5/id6744051740?l"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AppStoreImg />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.skgaidemobile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GooglePlayImg />
                </a>
                <a
                  href="https://www.rustore.ru/catalog/app/com.skgaidemobile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RuStoreImg />
                </a>
              </Box>
            </>
          ) : (
            <Box className={styles.infoText}>
              <p>
                Полис также будет доступен в приложении <span>Ю-Здоровье</span>
              </p>
            </Box>
          )}
        </Box>
      </Box>
      <DeclarationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAccept={handleAcceptDeclaration}
        textInfo={TextInfo}
      />

      <Box className={styles.btnBoxNext}>
        <CustomButton
          title="Далее"
          handleClick={handleNextStep}
          textColor="white"
          backgroundColor={colors.primary}
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
        />
      </Box>
    </Box>
  );
};
